import React, { useReducer } from 'react'
import AuthContext from './authContext'
import AuthReducer from './authReducer'
import { apiCall, setAuthToken } from '../../common/api'
import { response } from '../common'
import {
    USER_LOADED,
    GET_2FA_USER_DETAILS,
    LOGOUT,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './authTypes'

const AuthState = (props) => {
    const initialState = {
        token: localStorage.getItem('token'),
        isAuthenticated: null,
        isAdmin: null,
        loading: true,
        user: {},
        twoFactor_details: {
            record: [],
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(AuthReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    // Register User
    const register = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'register', formData, '', ''),
            ])
            resp.commonResponse(res.data, 'register')
        } catch (err) {
            resp.commonErrorResponse('register')
        }
    }

    // Check Email User
    const checkValidation = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'checkValidation', formData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'checkValidation')
        } catch (err) {
            resp.commonErrorResponse('checkValidation')
        }
    }

    // Login User
    const login = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'login', formData, '', ''),
            ])
            resp.commonResponse(res.data, 'login')
            if (res.data.status === 'success') {
                localStorage.setItem('token', res.data.data.token)
                loadUser()
            }
        } catch (err) {
            resp.commonErrorResponse('login')
        }
    }

    //2Factor Verification
    const get2faDetails = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'get2faDetails', formData, '', ''),
            ])
            const from = '2faDetails'
            if (res.data.status === 'success') {
                console.log(res.data.data.responseData, 'restttt')
                dispatch({
                    type: GET_2FA_USER_DETAILS,
                    payload: {
                        record: res.data.data.responseData.length
                            ? res.data.data.responseData
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('2fatoken')
        }
    }

    // Switch User
    const switchUser = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'switchuser', formData, '', ''),
            ])
            resp.commonResponse(res.data, 'switchuser')
            if (res.data.status === 'success') {
                if (global.session) {
                    sessionStorage.setItem('token', res.data.data.token)
                } else {
                    localStorage.setItem('token', res.data.data.token)
                }
                // loadUser()
            }
        } catch (err) {
            resp.commonErrorResponse('switchuser')
        }
    }

    // Load User
    const loadUser = async (token = '') => {
        if (token) {
            setAuthToken(token)
        } else if (process.env?.REACT_APP_OKTA_SIGNIN === 'true') {
            if (localStorage.oktaToken) {
                setAuthToken(localStorage.oktaToken)
            }
        } else {
            if (localStorage.token) {
                setAuthToken(localStorage.token)
            }
        }

        const [res] = await Promise.all([
            apiCall('post', 'validateUser', {}, '', ''),
        ])
        if (res.data.status === 'success') {
            dispatch({
                type: USER_LOADED,
                payload: {
                    data: res.data.data.responseData,
                },
            })
        } else if (res.data.status === 'error') {
            dispatch({
                type: LOGOUT,
            })
        } else {
            dispatch({
                type: LOGOUT,
            })
        }
    }

    const updateProfile = async (formData, noAlert) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'updateProfile', formData, '', ''),
            ])
            resp.commonResponse(res.data, 'updateProfile', noAlert)
        } catch (err) {
            resp.commonErrorResponse('updateProfile', noAlert)
        }
    }

    const updatePreference = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'updatePreference',
                    formData,
                    '',
                    'user/preference'
                ),
            ])
            resp.commonResponse(res.data, 'updatePreference')
        } catch (err) {
            resp.commonErrorResponse('updatePreference')
        }
    }

    // Log out
    const logout = () =>
        dispatch({
            type: LOGOUT,
        })

    // Clear Response
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <AuthContext.Provider
            value={{
                token: state.token,
                isAuthenticated: state.isAuthenticated,
                isAdmin: state.isAdmin,
                loading: state.loading,
                user: state.user,
                twoFactor_details: state.twoFactor_details,
                responseStatus: state.responseStatus,
                register,
                updateProfile,
                updatePreference,
                get2faDetails,
                checkValidation,
                login,
                logout,
                loadUser,
                switchUser,
                clearResponse,
            }}
        >
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthState
